<div class="data" *ngFor="let data of mapData">

    <div class="data-block">
        <p>Name</p>
        <p>:</p>
        <p>{{data.userName}}</p>
    </div>

    <div class="data-block">
        <p>Last Date</p>
        <p>:</p>
        <p>{{data.currentDateTime | date : 'medium'}}</p>
    </div>

</div>